import { computed, inject, type ComputedRef, type InjectionKey, type VNodeChild } from 'vue'
import type { ButtonSize } from '../../types'

export interface UiLocale {
  locale?: string
  Empty?: { description?: string }
  global?: { placeholder?: string }
  DatePicker?: { lang?: { placeholder?: string; rangePlaceholder?: [string, string]; today?: string; now?: string; ok?: string; clear?: string }; timePickerLocale?: { placeholder?: string } }
  TimePicker?: { placeholder?: string }
  Pagination?: { items_per_page?: string; jump_to?: string; page?: string; prev_page?: string; next_page?: string; prev_5?: string; next_5?: string }
  Modal?: { okText?: string; cancelText?: string }
  Popconfirm?: { okText?: string; cancelText?: string }
  Image?: { preview?: string }
  Upload?: { uploading?: string; removeFile?: string; uploadError?: string; previewFile?: string }
  Table?: { filterConfirm?: string; filterReset?: string; filterTitle?: string; selectAll?: string }
}

export interface ConfigProviderProps {
  componentSize?: ButtonSize
  componentDisabled?: boolean
  locale?: UiLocale
  getPopupContainer?: (triggerNode: HTMLElement) => HTMLElement
  renderEmpty?: (componentName?: string) => VNodeChild
}

export const configProviderKey: InjectionKey<ComputedRef<ConfigProviderProps>> = Symbol.for('xjlv2.ui.config')
export function useUiConfig() {
  return inject(configProviderKey, computed<ConfigProviderProps>(() => ({})))
}
